(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hyla-avis"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
    var observateur = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('est-visible'); observateur.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -15% 0px' }) : null;

    function carrousel(section) {
      var liste = section.querySelector('[data-hy-avis-liste]');
      var nav = section.querySelector('[data-hy-avis-nav]');
      var etat = section.querySelector('[data-hy-avis-etat]');
      if (!liste || !nav) return;
      var reels = Array.prototype.slice.call(liste.children);
      var n = reels.length;
      if (n < 2) return;

      // Copies avant et après la série : la boucle reste continue dans les deux sens.
      function copier(carte) {
        var c = carte.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('role');
        c.removeAttribute('aria-label');
        c.removeAttribute('data-hy-bloc');
        c.removeAttribute('data-shopify-editor-block');
        c.classList.add('hy-avis__carte--copie');
        return c;
      }
      reels.forEach(function (c) { liste.insertBefore(copier(c), reels[0]); });
      reels.forEach(function (c) { liste.appendChild(copier(c)); });
      section.classList.add('hy-avis--carrousel');
      nav.hidden = false;

      var index = n;   // première vraie carte
      var pas = 0;     // largeur d'une carte + écart
      function mesurer() {
        var a = liste.children[0].getBoundingClientRect();
        var b = liste.children[1].getBoundingClientRect();
        pas = b.left - a.left;
      }
      function poser(anime) {
        liste.style.transition = anime && !reduit.matches ? '' : 'none';
        liste.style.transform = 'translate3d(' + (-index * pas).toFixed(1) + 'px,0,0)';
        if (!anime) { void liste.offsetWidth; liste.style.transition = ''; }
      }
      // Revenue dans les copies : saut invisible vers la carte identique de la vraie série.
      function recaler() {
        if (index >= 2 * n) { index -= n; poser(false); }
        else if (index < n) { index += n; poser(false); }
      }
      function annoncer() {
        if (etat) etat.textContent = 'Avis ' + (((index - n) % n + n) % n + 1) + ' sur ' + n;
      }
      function aller(cible, dire) {
        if (index >= 2 * n || index < n) { var decalage = cible - index; recaler(); cible = index + decalage; }
        index = Math.max(0, Math.min(3 * n - 1, cible));
        poser(true);
        if (reduit.matches) recaler();
        if (dire) annoncer();
      }
      liste.addEventListener('transitionend', function (e) { if (e.target === liste && e.propertyName === 'transform') recaler(); });
      nav.querySelector('[data-hy-avis-prec]').addEventListener('click', function () { aller(index - 1, true); });
      nav.querySelector('[data-hy-avis-suiv]').addEventListener('click', function () { aller(index + 1, true); });

      // Glisser au doigt ou à la souris (le défilement vertical de la page reste libre).
      var depart = null;
      liste.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        recaler();
        depart = { x: e.clientX, y: e.clientY, t: Date.now(), base: -index * pas, actif: false, id: e.pointerId };
      });
      liste.addEventListener('pointermove', function (e) {
        if (!depart || e.pointerId !== depart.id) return;
        var dx = e.clientX - depart.x, dy = e.clientY - depart.y;
        if (!depart.actif) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { depart = null; return; }
          depart.actif = true;
          try { liste.setPointerCapture(e.pointerId); } catch (err) {}
          section.classList.add('hy-avis--glisse');
        }
        liste.style.transform = 'translate3d(' + (depart.base + dx).toFixed(1) + 'px,0,0)';
      });
      function lacher(e) {
        if (!depart || e.pointerId !== depart.id) return;
        var d = depart;
        depart = null;
        section.classList.remove('hy-avis--glisse');
        if (!d.actif) return;
        var dx = e.clientX - d.x;
        var vitesse = dx / Math.max(1, Date.now() - d.t);
        var cartes = Math.round(-dx / pas);
        if (cartes === 0 && Math.abs(vitesse) > 0.3) cartes = vitesse < 0 ? 1 : -1;
        cartes = Math.max(1 - n, Math.min(n - 1, cartes));
        aller(index + cartes, true);
      }
      liste.addEventListener('pointerup', lacher);
      liste.addEventListener('pointercancel', lacher);
      liste.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Éditeur de thème : sélectionner un avis l'amène au début du carrousel.
      section.addEventListener('shopify:block:select', function (e) {
        var i = reels.indexOf(e.target.closest('[data-hy-bloc]'));
        if (i > -1) aller(n + i, false);
      });

      var minuteur = 0;
      window.addEventListener('resize', function () {
        window.clearTimeout(minuteur);
        minuteur = window.setTimeout(function () { mesurer(); poser(false); }, 120);
      });
      mesurer();
      poser(false);
    }

    function preparer() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-hy-avis]:not(.hy-avis--prete)'), function (s) {
        s.classList.add('hy-avis--prete');
        carrousel(s);
        // Fondu à l'arrivée, sauf pour une section déjà à l'écran (pas de disparition-réapparition).
        if (!observateur || reduit.matches || s.getBoundingClientRect().top < window.innerHeight) return;
        s.classList.add('hy-avis--anime');
        observateur.observe(s);
      });
    }
    document.addEventListener('shopify:section:load', preparer);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparer); else preparer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hyla-editorial"] && !Shopify.designMode) return;
  try {
    
  /* Accroche qui glisse à l'horizontale au défilement, comme sur hyla.com (écrans de 1200 px et plus) :
     elle avance avec la page et retrouve sa place d'origine, entière, quand elle arrive un peu sous
     le milieu de l'écran (60 % de la hauteur) ; caler ce repère sur le milieu de la section la
     montrait entière trop tard, déjà dans le tiers haut. Photo à gauche : vers la droite ; photo
     à droite : vers la gauche (réglage « Animation au défilement » pour forcer un sens). */
  (function () {
    var large = window.matchMedia('(min-width: 1200px)');
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
    var accroches = [];
    var attente = false;
    function maj() {
      attente = false;
      var actif = large.matches && !reduit.matches;
      var vh = window.innerHeight;
      var amplitude = window.innerWidth * 0.3;
      for (var i = 0; i < accroches.length; i++) {
        var a = accroches[i];
        if (!actif || !a.sens) { a.el.style.transform = ''; continue; }
        var r = a.el.getBoundingClientRect();
        var ecart = (0.6 * vh - (r.top + r.height / 2)) / (vh + r.height);
        ecart = Math.min(0.6, Math.max(-0.6, ecart));
        a.el.style.transform = 'translate3d(' + (ecart * 2 * amplitude * a.sens).toFixed(1) + 'px,0,0)';
      }
    }
    function demander() { if (!attente) { attente = true; window.requestAnimationFrame(maj); } }
    function collecter() {
      accroches = Array.prototype.map.call(document.querySelectorAll('.hy-edito__accroche[data-hy-defile]'), function (el) {
        var section = el.closest('.hy-edito') || el;
        var mode = el.getAttribute('data-hy-defile');
        var sens = mode === 'gauche' ? -1 : mode === 'droite' ? 1 : mode === 'aucune' ? 0 : (section.classList.contains('hy-edito--img-right') ? -1 : 1);
        return { el: el, section: section, sens: sens };
      });
      maj();
    }
    window.addEventListener('scroll', demander, { passive: true });
    window.addEventListener('resize', demander);
    if (large.addEventListener) { large.addEventListener('change', demander); reduit.addEventListener('change', demander); }
    document.addEventListener('shopify:section:load', collecter);
    document.addEventListener('shopify:section:unload', function () { window.setTimeout(collecter, 0); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collecter); else collecter();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hyla-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
    var large = window.matchMedia('(min-width: 992px)');
    var pieds = [];
    var attente = false;
    function borne(v) { return Math.min(1, Math.max(0, v)); }
    // « power1.out » : l'accélération par défaut de GSAP, utilisée par hyla.com.
    function lisse(p) { return 1 - (1 - p) * (1 - p); }
    function poser(liste, y, echelle) {
      for (var i = 0; i < liste.length; i++) {
        liste[i].style.transform = (y === 0 && echelle === 1) ? '' : 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(' + echelle.toFixed(4) + ')';
      }
    }
    function maj() {
      attente = false;
      var vh = window.innerHeight;
      for (var i = 0; i < pieds.length; i++) {
        var f = pieds[i];
        var a1 = f.querySelectorAll('.hf-ani-1'), a2 = f.querySelectorAll('.hf-ani-2'), a3 = f.querySelectorAll('.hf-ani-3');
        if (reduit.matches) { poser(a1, 0, 1); poser(a2, 0, 1); poser(a3, 0, 1); continue; }
        var r = f.getBoundingClientRect();
        var h = Math.max(1, r.height);
        // Repères ScrollTrigger de hyla.com : « top 70% → top top », « top 100% (80 % sur téléphone) → bottom bottom », « top 10% → bottom bottom ».
        var p1 = lisse(borne((0.7 * vh - r.top) / (0.7 * vh)));
        var p3 = lisse(borne((0.1 * vh - r.top) / Math.max(1, h - 0.9 * vh)));
        if (large.matches) {
          var p2 = lisse(borne((vh - r.top) / h));
          poser(a1, -300 * (1 - p1), 0.9 + 0.1 * p1);
          poser(a2, -900 * (1 - p2), 0.9 + 0.1 * p2);
        } else {
          var p2m = lisse(borne((0.8 * vh - r.top) / Math.max(1, h - 0.2 * vh)));
          poser(a1, -300 * (1 - p1), 1);
          poser(a2, -400 * (1 - p2m), 1);
        }
        poser(a3, -50 * (1 - p3), 1);
      }
    }
    function demander() { if (!attente) { attente = true; window.requestAnimationFrame(maj); } }
    function collecter() { pieds = Array.prototype.slice.call(document.querySelectorAll('[data-hf]')); maj(); }
    window.addEventListener('scroll', demander, { passive: true });
    window.addEventListener('resize', demander);
    if (large.addEventListener) { large.addEventListener('change', demander); reduit.addEventListener('change', demander); }
    document.addEventListener('shopify:section:load', collecter);
    document.addEventListener('shopify:section:unload', function () { window.setTimeout(collecter, 0); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collecter); else collecter();
  })();

  } catch(e) { console.error(e); }
})();
})();
